__turbopack_context__.v({
  "container": "ProhibitedNotice-module__dMclvq__container",
  "outerContainer": "ProhibitedNotice-module__dMclvq__outerContainer",
});
